import React, { useEffect } from "react";
import { app } from "@microsoft/teams-js";
import { getAuthenticationConsentMetadata } from '../../apis/messageListApi';
import { initializeTeamsApp } from "../../helpers/teamsApp";

const SignInSimpleStart: React.FunctionComponent = () => {
    useEffect(() => {
        initializeTeamsApp().then(() => {

            app.getContext().then((context: app.Context) => {
                const windowLocationOriginDomain = window.location.origin.replace("https://", "");
                const login_hint = context.user?.userPrincipalName ? context.user?.userPrincipalName : "";
    
                getAuthenticationConsentMetadata(windowLocationOriginDomain, login_hint).then(result => {
                    window.location.assign(result.data);
                });
            });
        });
    });

    return (
        <></>
    );
};

export default SignInSimpleStart;